import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { ExternalLink } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL;

export default function AdBanner() {
  const { locationData } = useContext(AuthContext);
  const [ad, setAd] = useState(null);

  useEffect(() => {
    fetchAd();
  }, [locationData]);

  const fetchAd = async () => {
    try {
      const params = new URLSearchParams();
      if (locationData) {
        if (locationData.country) params.append('country', locationData.country);
        if (locationData.state) params.append('state', locationData.state);
        if (locationData.town) params.append('town', locationData.town);
      }

      const response = await axios.get(`${API}/api/ads?${params.toString()}`);
      if (response.data.length > 0) {
        const selectedAd = response.data[0];
        setAd(selectedAd);
        
        // Track impression
        await axios.post(`${API}/api/ads/${selectedAd.ad_id}/impression`);
      }
    } catch (error) {
      console.error('Error fetching ad:', error);
    }
  };

  const handleClick = async () => {
    if (ad) {
      try {
        await axios.post(`${API}/api/ads/${ad.ad_id}/click`);
        window.open(ad.link_url, '_blank');
      } catch (error) {
        console.error('Error tracking click:', error);
      }
    }
  };

  if (!ad) return null;

  return (
    <div 
      onClick={handleClick}
      className="bg-white border-4 border-black rounded-2xl p-6 shadow-brutal cursor-pointer hover:shadow-brutal-lg transition-shadow mb-6"
    >
      <div className="flex items-start gap-4">
        <img 
          src={ad.image_url} 
          alt={ad.title} 
          className="w-32 h-32 object-cover rounded-xl border-2 border-black"
        />
        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <div>
              <div className="text-xs font-bold text-slate-500 mb-1">SPONSORED</div>
              <h3 className="text-xl font-black text-slate-900 mb-1" style={{fontFamily: 'Outfit'}}>{ad.title}</h3>
              <p className="text-sm text-slate-600">{ad.description}</p>
            </div>
            <ExternalLink className="w-5 h-5 text-slate-400" />
          </div>
          <div className="mt-3">
            <span className="text-xs font-semibold text-indigo-600">{ad.business_name}</span>
          </div>
        </div>
      </div>
    </div>
  );
}